export enum FontStyle {
  NORMAL = 'NORMAL',
  ITALIC = 'ITALIC'
}
